import React from 'react'
import { PhotovoltaicIcon } from 'src/Libs/flow/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { localizeEmobilityNumber } from '../utils/localize-emobility-number'
import { Card } from './Card'

interface Props {
  energyKWh: number
}

export const SolarEnergyCard: React.FC<Props> = ({ energyKWh }) => {
  const { t } = useCustomTranslation()

  return (
    <Card
      Icon={PhotovoltaicIcon}
      label={t('emobility.chargingSession.totalSolarEnergyCharged')}
      value={t('common.format.kwh', '', { value: localizeEmobilityNumber(energyKWh) })}
    />
  )
}
